import { Button, Card, SingleDatePicker, Tabs } from '@sede-enterprise/shell-ds-react-framework'
import React, { useEffect, useState } from 'react'
import momentGenerateConfig from 'rc-picker/lib/generate/moment'
import { Download } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components'
import AssetMonthlyChart from './AssetMonthlyChart'
import AssetPageChart from './AssetPageChart'
import moment from 'moment'
import { handleDateChange } from '../../util/handleDateChange'
import { DEFAULT_STATS_SPEC } from '../../util/constants';
import useAssetStatistics from './hooks/useAssetStatistics';
import { generateLayout, generateMonthlyUsageData, generatePageLayout, generatePageUsageData } from './utils/chartUtils';
import { downloadUsageStats } from './utils/downloadUtils';


const AssetStatistics = ({ selectedSite }) => {

    const [startDate, setStartDate] = useState(DEFAULT_STATS_SPEC.initStart);
    const [endDate, setEndDate] = useState(DEFAULT_STATS_SPEC.initEnd);
    const [stackView, setStackView] = useState(true);

    const [startErrorText, setStartErrorText] = useState(null);
    const [inValidStartDate, setInValidStartDate] = useState(null);

    const [endErrorText, setEndErrorText] = useState(null);
    const [inValidEndDate, setInValidEndDate] = useState(null);

    const [currTab, setCurrTab] = useState('monthly')

    useEffect(() => {
        if (selectedSite?.length === 1 && !stackView) {
            setStartDate(moment().subtract(2, "year"));
            setEndDate(moment());
        }
    }, [selectedSite, stackView]);

    useEffect(() => {
        setStartDate(moment().subtract(2, "year"));
        setEndDate(moment());
    }, [currTab]);

    const { statisticsData, monthlyLoading, sitePageData, sitePageLoading } = useAssetStatistics(selectedSite, startDate, endDate);
    const dataToPlot = generateMonthlyUsageData(statisticsData, selectedSite, stackView);
    const dataToPlot2 = generatePageUsageData(sitePageData);
    const layout = generateLayout(selectedSite, stackView);
    const layout2 = generatePageLayout();

    return (
        <div className='asset-statistics-container'>
            <div className='asset-chart-controls'>
                <div className='chart-date-container'>
                    <div className='start-date-wrapper'>
                        <p className="data-label">Start Date</p>
                        <SingleDatePicker
                            placeholder='Start Date'
                            generateConfig={momentGenerateConfig}
                            config="custom"
                            format="DD/MM/yyyy"
                            disabledDate={(curr) => curr ? curr.isAfter(moment().toDate()) : false}
                            value={!inValidStartDate && startDate ? startDate : inValidStartDate ? inValidStartDate : null}
                            onChange={(date) => {
                                setStartErrorText(null)
                                setInValidStartDate(null)
                                if (date.isBefore(endDate)) {
                                    handleDateChange(date, startDate, setStartDate, "DD/MM/yyyy")
                                }
                                else if (date.isAfter(endDate)) {
                                    setStartErrorText("Start date cannot be after end date")
                                    setInValidStartDate(date)
                                }
                            }
                            }
                            allowClear={false} />
                        <p className="data-label error-label">{startErrorText}</p>
                    </div>
                    <div className='end-date-wrapper'>
                        <p className="data-label">End Date</p>
                        <SingleDatePicker
                            generateConfig={momentGenerateConfig}
                            config="custom"
                            format="DD/MM/yyyy"
                            disabledDate={(curr) => curr ? curr.isAfter(moment().toDate()) : false}
                            value={!inValidEndDate && endDate ? endDate : inValidEndDate ? inValidEndDate : null}
                            onChange={(date) => {
                                setEndErrorText(null)
                                setInValidEndDate(null)
                                if (date.isAfter(startDate)) {
                                    handleDateChange(date, endDate, setEndDate, "DD/MM/yyyy")
                                }
                                else if (date.isBefore(startDate)) {
                                    setEndErrorText("End date cannot be before start date")
                                    setInValidEndDate(date)
                                }
                            }
                            }
                            allowClear={false} />
                        <p className="data-label error-label">{endErrorText}</p>
                    </div>
                </div>
                <Button iconOnly icon={<Download />} onClick={() => downloadUsageStats(dataToPlot, dataToPlot2)} />
            </div>
            <br />
            <Card bodyPadding={false} className='asset-chart-body'>
                <Tabs onTabClick={(tab) => setCurrTab(tab)} tabBarStyle={
                    {
                        borderBottom: '1px solid #E0E0E0',
                    }
                }
                    items={[
                        {
                            label: 'Asset Monthly Usage',
                            key: 'monthly',
                            children: <AssetMonthlyChart selectedSite={selectedSite} stackView={stackView} setStackView={setStackView} dataToPlot={dataToPlot} layout={layout} loading={monthlyLoading} statisticsData={statisticsData} />
                        },

                        {
                            label: 'Asset Page Usage',
                            key: 'page',
                            children: <AssetPageChart loading={sitePageLoading} dataToPlot={dataToPlot2} layout={layout2} sitePageData={sitePageData} />
                        }

                    ]}
                />
            </Card>
        </div>
    )
}

export default AssetStatistics